<button
  #overlayButton
  tabindex="-1"
  aria-hidden="true"
  type="button"
  class="hidden"
  [mobiUiOverlay]="overlay"
></button>

<ng-template #overlay let-overlay>
  <mobi-ui-overlay-major
    size="sm"
    [showCloseOverlayButton]="false"
    trapFocus
    class="is-height-shrink-to-content lg:!min-w-[640px]"
  >
    <button
      type="button"
      aria-label="Close overlay"
      (click)="toggle()"
      class="mobi-ui-btn-icon-major !absolute right-[calc(5*(var(--mobi-ui-scale-unit)))] top-[calc(5*(var(--mobi-ui-scale-unit)))] cursor-pointer z-[50]"
    >
      <mobi-ui-icon-major name="the_x" class="md" />
    </button>

    <div class="p-8 pt-16">
      <h2 class="mobi-ui-font-h3 !pb-0">
        {{
          'prerollout_overlay_title'
            | texts: { context: 'frontend', default: 'Titel Prerollout Overlay' }
        }}
      </h2>
      <p class="mobi-ui-font-copy mobi-ui-margin-b-xxl">
        {{
          'prerollout_overlay_description'
            | texts
              : {
                  context: 'frontend',
                  default: 'Zusatztext Prerollout Overlay.',
                }
        }}
      </p>

      @if (showRadioGroup()) {
        <p class="mobi-ui-font-copy mobi-ui-margin-b-sm font-bold italic">
          {{
            'prerollout_zip_heading'
              | texts: { context: 'frontend', default: 'Postleitzahl oder Ort' }
          }}
        </p>
      }
      <mobi-ui-typeahead-major
        #zipTypeahead
        class="mb-4"
        [aria-label]="
          'prerollout_zip_label'
            | texts: { context: 'frontend', default: 'Postleitzahl oder Ort' }
        "
        [placeholder]="
          'prerollout_zip_label'
            | texts: { context: 'frontend', default: 'Postleitzahl oder Ort' }
        "
        [autoSelectFirstOrMatch]="true"
        [matchOptions]="false"
        autocomplete="off"
        (valueChanges)="onLocationSelected($event)"
      >
        @for (location of locations$ | async; track location) {
          <mobi-ui-typeahead-option-major [value]="location">
            {{ location }}
          </mobi-ui-typeahead-option-major>
        }
      </mobi-ui-typeahead-major>
      @if (hasSearched() && !loading() && (locations$ | async)?.length === 0) {
        <div class="mobi-ui-card-silent mobi-ui-ink-blue">
          <mobi-ui-text-block-major icon="info" class="items-center">
            {{
              'prerollout_no_results'
                | texts
                  : {
                      context: 'frontend',
                      default: 'Ungültige Eingabe. Bitte versuchen Sie es erneut.',
                    }
            }}
          </mobi-ui-text-block-major>
        </div>
      }
      @if (showRadioGroup() && prerolloutAvailable()) {
        <p
          class="mobi-ui-font-copy mobi-ui-margin-b-sm mobi-ui-margin-t-xxl font-bold italic"
        >
          {{
            'prerollout_coverage_heading'
              | texts
                : {
                    context: 'frontend',
                    default:
                      'Hausrat & Privathaftpflicht – die in der Schweiz übliche Kombination',
                  }
          }}
        </p>
        <mobi-ui-radio-button-group-major
          [value]="selectedCoverage()"
          (valueChange)="onCoverageSelected($event)"
        >
          <mobi-ui-radio-button-major icon="copy" value="combined">
            {{
              'prerollout_coverage_combined'
                | texts: { context: 'frontend', default: 'Hausrat & Privathaftpflicht' }
            }}
          </mobi-ui-radio-button-major>
          <mobi-ui-radio-button-major icon="document" value="household">
            {{
              'prerollout_coverage_household'
                | texts: { context: 'frontend', default: 'Nur Hausrat' }
            }}
          </mobi-ui-radio-button-major>
        </mobi-ui-radio-button-group-major>
      }
    </div>
  </mobi-ui-overlay-major>
</ng-template>
